import { useCallback, useEffect } from "react";
import { useMappedState, useDispatch } from "redux-react-hook";
import {
  selectReceivedContactInvites,
  selectSentContactInvites
} from "../selectors/contacts.selectors";
import * as actions from "../actions/contacts.actions";

export function useReceivedContactInvites() {
  return useMappedState(selectReceivedContactInvites);
}

export function useSentContactInvites() {
  return useMappedState(selectSentContactInvites);
}

export function useCreateContactInviteRequest() {
  const dispatch = useDispatch();

  return useCallback((creator, target) => {
    dispatch(actions.createContactInviteAction(creator, target));
  }, []);
}

export function useUpdateContactInviteRequest() {
  const dispatch = useDispatch();

  return useCallback((id, status) => {
    dispatch(actions.updateContactInviteAction(id, status));
  }, []);
}

export function useFetchContactInvites() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.loadContactInvitesAction());
  }, []);
}



// WEBPACK FOOTER //
// ./src/redux/effects/contacts.effects.js